<template>
<transition name="el-zoom-in-top">
  <div class="content-wrapper">
     <!-- Content Header (Page header) -->
     <section class="content-header">
        <!-- <h1>Forms Radio<small><i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
        <ol class="breadcrumb">
           <li>
              <router-link to="/"> <i class="ti-home"></i></router-link>
           </li>
           <li><a href="#">Forms</a></li>
           <li class="active">Radio</li>
        </ol>
     </section>
     <!-- Main content -->
     <section class="content">
        <!-- Default box -->
        <div class="box">
           <div class="box-body">
              <h5>Enter Publisher's Name</h5>
              <p :class="{ 'control': true }">
                 <el-input class = "publisher-input" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('name') }" name="name" type="text" placeholder="Name" v-model="credentials.name"></el-input>
                 <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
              <hr>
              <h5>Enter E-Mail</h5>
              <p :class="{ 'control': true }">
                 <el-input class = "publisher-input" v-validate="'required|email'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('email') }" name="email" type="text" placeholder="Email" v-model="credentials.email"></el-input>
                 <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
              <hr>
              <h5>Enter Contact Number</h5>
              <p :class="{ 'control': true }">
                 <el-input class = "publisher-input" v-validate="'required'" data-vv-delay="1000" :class="{'input': true, 'is-danger': errors.has('number') }" name="number" type="number" placeholder="Contact Number" v-model="credentials.number"></el-input>
                 <span v-show="errors.has('number')" class="help is-danger">{{ errors.first('number') }}</span>
              <hr>
              <h5>Select Country</h5>
              <el-select v-model="credentials.countryId" placeholder="Select">
                 <el-option-group
                    v-for="option in countryOptions"
                    :key="option.id"
                    :label="option.name"
                    :value = "option.id">
                    <el-option
                       v-for="option in countryOptions"
                       :key="option.id"
                       :label="option.name"
                       :value="option.id">
                    </el-option>
                 </el-option-group>
              </el-select>
              <hr>
              <h5>Select Currency</h5>
              <el-select v-model="credentials.currencyId" placeholder="Select">
                 <el-option-group
                    v-for="option in currenciesOptions"
                    :key="option.id"
                    :label="option.code"
                    :value="option.id">
                    <el-option
                       v-for="option in currenciesOptions"
                       :key="option.id"
                       :label="option.code"
                       :value="option.id">
                    </el-option>
                 </el-option-group>
              </el-select>
              <hr>
              <button class="btn btn-primary" @click="submit()">Access</button>
           </div>
           <!-- /.box-body -->
        </div>
        <!-- /.box -->
     </section>
     <!-- /.content -->
  </div>
</transition>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      credentials: {
        name: '',
        email: '',
        number: '',
        countryId: '',
        currencyId: ''

      },
      message: '',
      countryId: '',
      currencyId: '',
      countryOptions: [],
      currenciesOptions: []

    }
  },
  beforeCreate: function () {
    this.$nextTick(function () {
      console.log(this.$route.params)
      const self = this
      axios.all([
        axios.get(BASE_URL + 'v1/publishers/' + this.$route.params.uuid + '/'),
        axios.get(BASE_URL + 'v1/countries/'),
        axios.get(BASE_URL + 'v1/currencies/')
      ])
               .then(axios.spread(function (formData, countries, currencies) {
                 self.countryOptions = countries.data
                 self.currenciesOptions = currencies.data
                 self.credentials.name = formData.data.name
                 self.credentials.number = formData.data.contact_number
                 self.credentials.email = formData.data.contact_email
                 self.credentials.countryId = formData.data.country.id
                 self.credentials.currencyId = formData.data.currency.id
               }))
               .catch(error => console.log(error))
    })
  },
  methods: {
    submit () {
      axios.put(BASE_URL + 'v1/publishers/' + this.$route.params.uuid + '/', {
        name: this.credentials.name,
        contact_email: this.credentials.email,
        contact_number: this.credentials.number,
        country: this.credentials.countryId,
        currency: this.credentials.currencyId,
        uuid: this.$route.params.uuid
      })
               .then(response => {
                 this.message = 'Success'
               })
               .catch(error => {
                 if (error.response.status == 400) {
                   if (error.response.data.new_password2[0]) {
                     this.message = error.response.data.new_password2[0]
                   }
                 }
               })
    }
  }
}
</script>
<style>
.publisher-input{
  width: 50%;
}
</style>


// WEBPACK FOOTER //
// EditPublisher.vue?2e9a5389